import navbarSearchAndPinList from '@/layouts/components/navbarSearchAndPinList'
import themeConfig from '@/../themeConfig.js'
import colors from '@/../themeConfig.js'

export const state = {
    isSidebarActive: true,
    isMobile: window.innerWidth < 700,
    breakpoint: null,
    sidebarWidth: "default",
    reduceButton: themeConfig.sidebarCollapsed,
    bodyOverlay: false,
    sidebarItemsMin: false,
    theme: themeConfig.theme || 'light',
    navbarSearchAndPinList: navbarSearchAndPinList,
    currentUser: {
        id_pessoa: 0,
        nome: '',
        foto: null
    },
    authToken: null,
    themePrimaryColor: colors.primary,
    daterange: {
        startDate: new Date(),
        endDate: new Date(),
    },
    dashboard: {
        date: new Date(),
        idUser: null,
        comissoes: {},
        tickets: {},
        map: {},
    },
    relatorioComissoes: {
        startDate: new Date(),
        endDate: new Date(),
        idUser: null,
        data: []
    },
};
